import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'bt-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
